import React, { useState } from 'react';
import { Button, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import axios from 'axios';

async function getHotelsFacilitiesServicesWorkflowstatus(aliceApi) {
    const result = [];

    // grab all the hotels
    const hotels = await aliceApi.get('/staff/v1/hotels').then(e => e.data);

    for (let i = 0; i < hotels.length; i++) {
        // grab facilities for each hotel
        const facilities = await aliceApi
            .get(`/staff/v1/hotels/${hotels[i].id}/facilities`)
            .then(e => e.data);

        // we also need workflow statuses
        const states = await aliceApi
            .get(`/staff/v1/hotels/${hotels[i].id}/workflowStates`)
            .then(e => e.data);

        // grab services for each hotel for each facility
        for (let j = 0; j < facilities.length; j++) {
            const services = await aliceApi
                .get(`/staff/v1/hotels/${hotels[i].id}/facilities/${facilities[j].id}/services`)
                .then(e => e.data);

            // add each option as a well defined list to result
            for (let k = 0; k < services.length; k++) {
                result.push({
                    hotelId: hotels[i].id,
                    hotelName: hotels[i].name,
                    hotelAddress: hotels[i].address,
                    facilityId: facilities[j].id,
                    facilityName: facilities[j].name,
                    serviceName: services[k].name,
                    serviceId: services[k].id,
                    states
                });
            }
        }
    }

    return result;
}

const AliceTester = ({
    apikey,
    user,
    pass,
    setAliceParams,
    setStatusCreateId,
    setStatusCancelId
}) => {
    const [selected, setSelected] = useState();
    const [statusCreated, setStatusCreated] = useState();
    const [statusCancel, setStatusCancel] = useState();
    const [list, setList] = useState([]);

    const loadData = () => {
        if (!apikey || !user || !pass) {
            return;
        }
        // init alice api axios instance
        const aliceApi = axios.create({
            baseURL: 'https://rapi.aliceapp.com/',
            auth: {
                username: user,
                password: pass
            }
        });
        aliceApi.interceptors.request.use(
            function (req) {
                // add apikey to all requests
                if (!req.url.includes('apikey=')) {
                    req.url += `${req.url.includes('?') ? '&' : '?'}apikey=${apikey}`;
                }
                return req;
            },
            function (error) {
                return Promise.reject(error);
            }
        );

        getHotelsFacilitiesServicesWorkflowstatus(aliceApi)
            .then(result => {
                setList(result);
            })
            .catch(console.log);
    };

    if (!apikey || !user || !pass) {
        return null;
    }

    if (list.length === 0) {
        return (
            <Grid container item xs={12} justifyContent="center">
                <Button variant="contained" onClick={() => loadData()}>
                    Load hotels / facilities / services
                </Button>
            </Grid>
        );
    }

    return (
        <>
            <Grid item xs={12}>
                <InputLabel htmlFor="alice-select">
                    Pick the target Hotel / Facility / Department
                </InputLabel>
                <Select
                    fullWidth
                    id="alice-select"
                    value={selected}
                    onChange={ev => {
                        setSelected(ev.target.value);
                        if (!ev.target.value) {
                            return;
                        }
                        const parts = ev.target.value.split('-');
                        if (parts.length === 3) {
                            setAliceParams(parts[0], parts[1], parts[2]);
                        }
                    }}
                >
                    {list.map((v, key) => (
                        <MenuItem
                            value={`${v.hotelId}-${v.facilityId}-${v.serviceId}`}
                            key={key}
                        >{`${v.hotelName} / ${v.facilityName} / ${v.serviceName}`}</MenuItem>
                    ))}
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel htmlFor="alice-select-2">Created status:</InputLabel>
                {!selected || (
                    <Select
                        fullWidth
                        id="alice-select-2"
                        value={statusCreated}
                        onChange={ev => {
                            setStatusCreated(ev.target.value);
                            setStatusCreateId(ev.target.value);
                        }}
                    >
                        {list
                            .find(v => `${v.hotelId}-${v.facilityId}-${v.serviceId}` === selected)
                            .states.map((v, key) => (
                                <MenuItem value={v.id} key={key}>
                                    {v.name}
                                </MenuItem>
                            ))}
                    </Select>
                )}
            </Grid>
            <Grid item xs={6}>
                <InputLabel htmlFor="alice-select-3">Cancelled status:</InputLabel>
                {!selected || (
                    <Select
                        fullWidth
                        id="alice-select-3"
                        value={statusCancel}
                        onChange={ev => {
                            setStatusCancel(ev.target.value);
                            setStatusCancelId(ev.target.value);
                        }}
                    >
                        {list
                            .find(v => `${v.hotelId}-${v.facilityId}-${v.serviceId}` === selected)
                            .states.map((v, key) => (
                                <MenuItem value={v.id} key={key}>
                                    {v.name}
                                </MenuItem>
                            ))}
                    </Select>
                )}
            </Grid>
        </>
    );
};

export default AliceTester;
